// extracted by mini-css-extract-plugin
export default {"list":"CheckList_list__V2d12","item":"CheckList_item__mk2ij"};